<div>
    <page-header
            [title]="'admin.entreprise.populations.onglets.usage' | translate"
            (onGoBack)="onGoBack()"
            [listeItems]="listeTabItems"
    ></page-header>

</div>

<list-view *ngIf="collabView" [liste]="collabView"></list-view>

<list-view *ngIf="roleView" [liste]="roleView"></list-view>